import http from 'hub-http/clients/apiClient';
import { useQuery, registerQuery } from 'data-fetching-client';
import { SENTRY_KEYS } from 'campaigns-lib/constants/sentry';
import Raven from 'raven-js';
export const GET_ASSOCIATED_ASSET_FIELD_NAME = 'campaignsPlatformComponentsAssociatedAsset';
const GET_ASSOCIATED_ASSET = registerQuery({
  fieldName: GET_ASSOCIATED_ASSET_FIELD_NAME,
  args: ['objectType', 'assetId', 'crmIdProperty'],
  fetcher({
    objectType,
    assetId,
    crmIdProperty
  }) {
    return http.post(`/crm-search/search`, {
      data: {
        count: 1,
        objectTypeId: objectType,
        fetchSource: false,
        fetchVersion: false,
        requestOptions: {
          includeAllValues: false,
          includeObjectVersion: false
        },
        filterGroups: [{
          filters: [{
            operator: 'EQ',
            property: crmIdProperty,
            value: assetId
          }]
        }]
      }
    }).then(response => response.results[0]);
  }
});
export function useFetchAssociatedAssetObjectId({
  objectType,
  assetId,
  crmIdProperty,
  skip
}) {
  var _queryResult$data;
  const isUsingObjectId = crmIdProperty === 'hs_object_id';
  const queryResult = useQuery(GET_ASSOCIATED_ASSET, {
    variables: {
      objectType,
      assetId: assetId,
      crmIdProperty
    },
    onError: error => Raven.captureException(error, {
      fingerprint: [SENTRY_KEYS.ASSOCIATED_ASSET_FETCH_FAILED],
      tags: {
        lib: 'campaigns-lib'
      }
    }),
    skip: !assetId || isUsingObjectId || skip
  });
  return {
    data: isUsingObjectId ? assetId : (_queryResult$data = queryResult.data) === null || _queryResult$data === void 0 ? void 0 : _queryResult$data[GET_ASSOCIATED_ASSET_FIELD_NAME].objectId,
    loading: queryResult.loading,
    error: queryResult.error,
    refetch: queryResult.refetch
  };
}